module.exports = __webpack_public_path__ + "img/psm_logo-inverse.45105872.png";